import React from 'react';
import '../styling/menus.css';

const Card = ({ title, subtitle, icon, onClick, cardClass }) => (
  <button className={`menu-card ${cardClass || ''}`} onClick={onClick}>
    <div className="menu-icon" aria-hidden>{icon}</div>
    <div className="menu-title">{title}</div>
    {subtitle && <div className="menu-subtitle">{subtitle}</div>}
  </button>
);

const SchedulingMenu = ({ goBack, toOutcomes, toSettings, logout, onSelect }) => {
  return (
    <div className="menu-screen">
      <h1 className="menu-heading">Scheduling/Communication Error</h1>
      <p className="menu-sub">Select the type of scheduling or communication error</p>
      <div className="menu-grid three-cols">
        <Card title="Appointment Scheduling" subtitle="Double bookings, incorrect times, and scheduling conflicts" icon="📅" onClick={() => onSelect('Scheduling - Appointment')} cardClass="scheduling" />
        <Card title="Patient Communication" subtitle="Missed calls, incorrect information, and communication breakdowns" icon="💬" onClick={() => onSelect('Scheduling - Communication')} cardClass="scheduling" />
        <Card title="Documentation Error" subtitle="Chart errors, missing information, and record-keeping issues" icon="📄" onClick={() => onSelect('Scheduling - Documentation')} cardClass="scheduling" />
        <Card title="System/Process Error" subtitle="Workflow problems, system failures, and process breakdowns" icon="⚙️" onClick={() => onSelect('Scheduling - System/Process')} cardClass="scheduling" />
      </div>
    </div>
  );
};

export default SchedulingMenu;


